import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import React from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import PageHeader from "../../../../../../Component/Headers/pageHeader";
import Stepper from "../../../../../../Component/Stepper";
import Components from "./Components";
import Define from "./Define";
import Design from "./Design";

const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {
    // padding: theme.spacing.unit * 3,
  },
  drawerPaper: {
    width: "30%",
  },
});

class FlexiblePlan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      AllStep: [],
      completed: false,
    };

    this.setStep = this.setStep.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.onPrevClick = this.onPrevClick.bind(this);
    this.updateStepsData = this.updateStepsData.bind(this);
  }

  componentDidMount() {
    this.updateStepsData();
  }

  updateStepsData() {
    const AllStep = [
      {
        component: (
          <Define
            {...this.props}
            {...this.state}
            onRef={(ref) =>
              this.setState({ child0: { ...ref, onCancel: this.props.onCancel } })
            }
            setStep={this.setStep}
            onNextClick={this.onNextClick}
          />
        ),
        iserror: false,
        label: "Define",
        step: 0,
      },
      {
        component: (
          <Components
            {...this.props}
            {...this.state}
            onRef={(ref) =>
              this.setState({
                child1: {
                  ...ref,
                  onCancel: this.props.onCancel,
                  onPrev: this.onPrevClick,
                },
              })
            }
            onNextClick={this.onNextClick}
            setStep={this.setStep}
          />
        ),
        iserror: false,
        label: "Component selection",
        step: 1,
      },
      {
        component: (
          <Design
            {...this.props}
            {...this.state}
            onRef={(ref) =>
              this.setState({
                child2: {
                  ...ref,
                  onCancel: this.props.onCancel,
                  onPrev: this.onPrevClick,
                },
              })
            }
            onNextClick={this.onNextClick}
            setStep={this.setStep}
          />
        ),
        iserror: false,
        label: "Component design",
        step: 2,
      },
    ];
    this.setState({ AllStep });
  }

  setStep(step, completed) {
    this.setState({ activeStep: step, completed });
  }

  onNextClick() {
    if (this.stepperref) {
      this.stepperref.handleNext();
    }
  }

  onPrevClick() {
    if (this.stepperref) {
      this.stepperref.handleBack();
    }
  }

  render() {
    const { child0, child1, child2 } = this.state;
    return (
      <IntlProvider locale="en" messages={""}>
        <div className="content-outer-wrapper">
          <Grid container>
            <Grid item xs={12} md={6} sm={12}>
              <PageHeader header="Create new flexible benefit plan" />
            </Grid>
          </Grid>
          <div style={{ display: "block", width: "100%", color: "red" }}>
            <Stepper
              AllStep={this.state.AllStep}
              onRef={(ref) => (this.stepperref = ref)}
              activeStep={this.state.activeStep}
              setStep={this.setStep}
              completed={this.state.completed}
              childs={[child0, child1, child2]}
            />
          </div>
        </div>
      </IntlProvider>
    );
  }
}
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withStyles(styles)(withSnackbar(FlexiblePlan))),
);
